import React from 'react';
import { Layout } from 'components/ds';
import { HTML5Backend } from 'react-dnd-html5-backend';
import FilteredModules from '../../../federation/FilteredModules';
import { GlobalStyle, Provider } from './Encapsulation.styles';

const PageTemplate = () => {
  return (
    <>
      <GlobalStyle />
      <FilteredModules componentName="provider">
        <Provider backend={HTML5Backend}>
          <Layout className="pwa-layout">
            <FilteredModules componentName="header" />
            <FilteredModules componentName="content" componentPage="home" />
            <FilteredModules componentName="footer" />
          </Layout>
        </Provider>
      </FilteredModules>
    </>
  );
};

export default PageTemplate;
